<div class="auth-card register-card animate__animated animate__fadeIn">
  <div class="auth-card-header">
    <h2>Crear Cuenta</h2>
    <p class="subtitle">Completá tus datos para registrarte</p>
  </div>

  <div class="registration-info">
    <i class="fas fa-info-circle"></i>
    <span>Validaremos tus datos de afiliación con tu D.N.I.</span>
  </div>

  <form [formGroup]="registerForm" (ngSubmit)="registerUser()" class="auth-form">
    <div class="form-group highlight-group">
      <label>Número de Identificación - D.N.I</label>
      <div class="input-wrapper">
        <i class="fas fa-id-card input-icon"></i>
        <input
          type="text"
          formControlName="identificacion"
          class="form-control"
          (input)="buscarAfiliadoGecros()"
          [(ngModel)]="identificacion"
          placeholder="Tu número de documento"
          [class.is-invalid]="getIdentificacionNoValida"
        />
        <div *ngIf="!flagDataGecros && viewSpinner" class="input-loader">
          <i class="fas fa-circle-notch fa-spin"></i>
        </div>
      </div>
      <small *ngIf="getIdentificacionNoValida" class="error-msg">Ingrese un D.N.I. válido</small>
      <div *ngIf="showTimeoutMessage && !flagDataGecros && !dataGecros" class="alert-msg">
        No encontramos tus datos. Contactá a administración.
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Nombre</label>
          <div class="input-wrapper">
            <input
              type="text"
              formControlName="nombrePersona"
              class="form-control no-icon"
              placeholder="Nombres"
              [class.is-invalid]="getNombreNoValido"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Apellido</label>
          <div class="input-wrapper">
            <input
              type="text"
              formControlName="apellidoPersona"
              class="form-control no-icon"
              placeholder="Apellidos"
              [class.is-invalid]="getApellidoNoValido"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>Correo Electrónico</label>
      <div class="input-wrapper">
        <i class="fas fa-envelope input-icon"></i>
        <input
          formControlName="email"
          type="email"
          class="form-control"
          placeholder="tu@email.com"
          [class.is-invalid]="emailNoValido"
        />
      </div>
      <small *ngIf="emailNoValido" class="error-msg">Ingrese un correo válido</small>
    </div>

    <div class="form-group">
      <label>Confirmar Correo</label>
      <div class="input-wrapper">
        <i class="fas fa-check-circle input-icon"></i>
        <input
          formControlName="confirmEmail"
          type="email"
          class="form-control"
          placeholder="Repetí tu email"
          [class.is-invalid]="confirmEmailNoValido"
        />
      </div>
      <small *ngIf="confirmEmailNoValido" class="error-msg">Los correos no coinciden</small>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Contraseña <small class="text-muted">(Mín. 6 - Máx. 10 car.)</small></label>
          <div class="input-wrapper">
            <input
              formControlName="password"
              [type]="showPasswordRegister ? 'text' : 'password'"
              class="form-control no-icon"
              placeholder="••••••••"
              [class.is-invalid]="passwordNoValido"
            />
            <button type="button" class="toggle-password" (click)="showPasswordRegister = !showPasswordRegister">
              <i class="far" [ngClass]="showPasswordRegister ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Confirmar</label>
          <div class="input-wrapper">
            <input
              formControlName="confirmPassword"
              [type]="showPasswordConfirm ? 'text' : 'password'"
              class="form-control no-icon"
              placeholder="••••••••"
              [class.is-invalid]="confirmPasswordNoValido"
            />
            <button type="button" class="toggle-password" (click)="showPasswordConfirm = !showPasswordConfirm">
              <i class="far" [ngClass]="showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <small *ngIf="passwordNoValido" class="error-msg mb-3 animate__animated animate__shakeX highlight-error">La contraseña debe tener entre 6 y 10 caracteres.</small>
    <small *ngIf="confirmPasswordNoValido" class="error-msg mb-3 animate__animated animate__shakeX highlight-error">Las contraseñas no coinciden.</small>

    <div class="legal-checks">
      <div class="check-item">
        <input type="checkbox" formControlName="proteccionDeDatos" id="chk-proteccion" />
        <label for="chk-proteccion">
          Acepto la <a (click)="openBlank('CFR')" class="link-inline">Cláusula de Protección de Datos</a>
        </label>
      </div>
      <div class="check-item">
        <input type="checkbox" formControlName="clausula" id="chk-privacidad" />
        <label for="chk-privacidad">
          Acepto la <a (click)="openBlank('PPSM')" class="link-inline">Política de Privacidad</a>
        </label>
      </div>
      <div class="check-item">
        <input type="checkbox" formControlName="aceptaTerminos" id="chk-terminos" />
        <label for="chk-terminos">
          Acepto los <a (click)="openBlank('TC')" class="link-inline">Términos y Condiciones</a>
        </label>
      </div>
    </div>

    <div class="recaptcha-container">
      <ngx-recaptcha2
        #captchaElem
        [siteKey]="siteKey"
        formControlName="recaptcha"
      >
      </ngx-recaptcha2>
    </div>

    <button type="submit" class="btn-primary mt-4" [disabled]="!flagFormaValido || loadingForm">
      <span *ngIf="!loadingForm">Registrarme</span>
      <span *ngIf="loadingForm"><i class="fas fa-spinner fa-spin"></i> Procesando...</span>
    </button>

    <div class="auth-footer">
      <p>¿Ya tenés cuenta? <a routerLink="/login" class="link-highlight">Iniciar Sesión</a></p>
    </div>
  </form>
</div>
